/*-------------------------------------------------------------------------
 *
 *	This component shows a grid where users can click to add X, Y coordinates
 *  to the regression model and the graph. This component changes the state 
 *  of the `x_array` and `y_array` arrays that are shown on the final graph.
 *	The coordinates are normalized with respect to the `width` and `height` 
 *  variables.
 *	
 * ------------------------------------------------------------------------
 */

import React, { useState } from "react";
import grid from "../../../assets/grid.png";
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core';

interface PointDrawerProps {
	addCoord: any;
	resetCoords: any;
}

const useStyles = makeStyles((theme) => ({
	buttonContainer: {
		display: 'flex',
		paddingBottom: '8px',
		paddingTop: '20px'
	},
	gridContainer: {
		display: 'flex',
		justifyContent: 'center',
	},
	coordinatesText: {
		display: 'flex',
	}
}));

export default function PointDrawer(props: PointDrawerProps) {
	const [width] = useState<number>(400);
	const [height] = useState<number>(400);
	const [x, setX] = useState<number>();
	const [y, setY] = useState<number>();
	const classes = useStyles();


 // shows X, Y coordinates as we hover around the grid
 function onMouseMove(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    setX(parseFloat((e.nativeEvent.offsetX / width).toFixed(3)));
    setY(parseFloat(((height - e.nativeEvent.offsetY) / height).toFixed(3)));
  }

  // adds points to the graph when we click on a certain coordinate
  function addCoord() {
    const coord = { x: x, y: y };
    props.addCoord(coord);
  }
  return (
    <div>
      <div className={classes.buttonContainer}>
        <Button variant="contained" color="primary" onClick={props.resetCoords}>
          reset
        </Button>
        <br />
      </div>
      <div className={classes.gridContainer}>
        <div
          onMouseMove={(e) => onMouseMove(e)}
          style={{
            width: width,
            height: height,
            backgroundColor: "rgba(100,100,100,0.1)",
            backgroundImage: `url(${grid})`,
          }}
          onClick={addCoord}
        />
      </div>
      <div>
        <div className={classes.coordinatesText}>
          <p>X: {x}</p>
        </div>
        <div className={classes.coordinatesText}>
          <p>Y: {y}</p>
        </div>
      </div>
    </div>
  );
}
